import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'

const DEBOUNCE_DELAY_MS = 300

interface PhoneFilterProps {
    phone: string
    onChange: (phone: string) => void
}

export function PhoneFilter({ phone, onChange }: PhoneFilterProps) {
    const [localValue, setLocalValue] = useState(phone)

    useEffect(() => {
        if (localValue === phone) {
            return
        }
        const timeoutId = setTimeout(() => {
            onChange(localValue)
        }, DEBOUNCE_DELAY_MS)
        return () => clearTimeout(timeoutId)
    }, [localValue, onChange, phone])

    useEffect(() => {
        setLocalValue(phone)
    }, [phone])

    const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(event.target.value)
    }

    return (
        <TextField
            label="Phone"
            placeholder="Search by phone..."
            value={localValue}
            onChange={handlePhoneChange}
            fullWidth
        />
    )
}
